<div class="container-fluid form-container  p-0 m-0 ">
  <div class="row h-100 g-0 min-vh-100">
    <div
      class="col-md-6  d-flex align-items-center justify-content-center bg-light position-relative min-vh-100 left-hero">
      <img ngSrc="/assets/images/trace-image.png" width="700" height="600" priority alt="hero image" class="hero-img" />
    </div>
    <div class="col-md-6 col-12 form-section d-flex align-items-center position-relative">
      <div class="w-100">
        <div class="form-box mx-auto">
          <div>
            <div class="top mb-3">
              <h1 class="text-brand-purple"> <b>Login</b></h1>
            </div>
            <form class="position-relative" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
              <div class="mb-2 position-relative">
                <label for="email">Email <span class="text-danger">*</span></label>
                <input type="test" class="form-control shadow-none rounded-12" formControlName="email" appFilledInput
                  formControlName="email" id="email">
                <span class="invalid-feedback" *ngIf="loginForm.get('email')?.errors?.['serverError'] ">{{
                  loginForm.get('email')?.errors?.['serverError']
                  }} </span>
              </div>
              <div class="mb-2">
                <label for="password">Password <span class="text-danger">*</span></label>
                <div class="position-relative">
                  <input [type]="showPassword ? 'text' : 'password'" formControlName="password" appFilledInput
                    class="form-control shadow-none rounded-12 " id="password">
                  <img [src]="showPassword ? 'assets/icons/eye-strike.svg' : 'assets/icons/eye.svg'"
                    (click)="togglePassword()" alt="eye" width="18" class="position-absolute top-12">
                  <span class="invalid-feedback" *ngIf="loginForm.get('password')?.errors?.['serverError'] ">{{
                    loginForm.get('password')?.errors?.['serverError']
                    }} </span>
                </div>
              </div>
              <div class="text-end">
                <a class="forgot-password fw-light  text-brand-purple text-decoration-none" id="linkForgotPassword"
                  [routerLink]="['/forgot-password']">
                  <small> Forgot Password? </small></a>

              </div>
              <br />
              <button type="submit" class="btn bg-brand-purple text-white w-100 rounded-12  mb-4"
                [disabled]="utility.hasEmptyFields(loginForm) || loader()">
                <app-spinner [loader]="loader()"></app-spinner>
                <span *ngIf="!loader()"> Login </span>
              </button>
              <div class="d-flex align-items-center mb-4">
                <hr class="flex-grow-1">
                <span class="px-3 text-secondary-grey small">Or Continue with</span>
                <hr class="flex-grow-1">
              </div>
              @if(false){
              <div class="d-flex gap-2 mb-3 social-btn">
                <button
                  class="btn bg-snow-white shadow-light flex-grow-1 py-2 rounded-12 d-flex align-items-center justify-content-center"
                  type="button">
                  <img src="assets/images/google-icon.svg" alt="Google" class="me-2" width="20" height="20">
                </button>
                <button type="button"
                  class="btn flex-grow-1 rounded-12  d-flex align-items-center  justify-content-center border-secondary">
                  <img src="assets/images/apple-icon.svg" alt="Apple" class="me-2" width="20" height="20">
                </button>
              </div>
              }
              <p class="text-center mt-2">
                Don't have an account?
                <a href="#" class="text-brand-purple" [routerLink]="['/signup']">Sign Up</a>
              </p>
            </form>
          </div>
        </div>
        <p class="text-center small footer-text position-absolute bottom-0 start-0 end-0 text-brand-dark-purple mb-2">
          2025 Trace.
          All rights reserved.</p>
      </div>
    </div>
  </div>
</div>